<template>
  <div>
    <ui-causes />
  </div>
  <div class="max-w-5xl mx-auto">

    <div class="pt-8">
      <ui-discover-more-org />
    </div>
  </div>
</template>
<script setup lang="ts">
definePageMeta({
  layout: 'dark'
})

import { useMediaQuery } from '@vueuse/core'
const isLargeScreen = useMediaQuery('(min-width: 1024px)')
useSeoMeta({
  title: isLargeScreen.value ? 'Scegli qui il regalo solidale che più ti rappresenta, fai sapere ai tuoi cari cosa ti sta più a cuore.' : 'Regala quello che ti sta a cuore.',
})
// Abilito la visualizzazione delle categorie di prodotto
const showActions = inject('showActions')
showActions.value = true;

</script>